<template>
    <div :class="['contact-block']">
        <div class="decoration">
            <img
                :src="layout.image.url"
                :alt="layout.image.alt"
                :title="layout.image.title"
            />
        </div>
        <Parallax class="gabarit" :effect="'translateY'" :power="0.0625" type="div">
        <!-- <div class="gabarit"> -->
            <div class="headline helper">
                <Parallax
                    class="caption"
                    :effect="'translateX'"
                    :power="-0.0625"
                >
                    {{layout.headline}}
                </Parallax>
            </div>
            <div class="sizer">
                <div class="headline">
                    <Parallax
                        class="caption"
                        :effect="'translateX'"
                        :power="-0.0625"
                    >
                        {{layout.headline}}
                    </Parallax>
                </div>
                <h2 v-html="layout.title"></h2>
                <p v-html="layout.description"></p>
                <Cta
                    :type="'router-link'"
                    :to="$trl({
                        name: layout.link,
                        params: {
                            locale: $route.params.locale
                        }
                    })"
                    :colors="{ hover: { background: '#114991' } }"
                    class="link"
                >
                    {{layout.caption}}
                </Cta>
            </div>
        </Parallax>
        </div>
    </div>
</template>

<script>
import Cta from '@/components/Cta'
import Parallax from '@/components/animation/Parallax'

export default {
    components: {
        Cta,
        Parallax
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.decoration
    padding-left: 5.9375%
    padding-right: 5.9375%
    text-align: right
    @include media-breakpoint-down($lg)
        padding-left: 0%
        padding-right: 0%
    img
        display: block
        margin-left: auto
        width: 73.18501%
        height: auto
        @include media-breakpoint-down($lg)
            width: 100%
.gabarit
    position: relative
    z-index: 1
    color: #ffffff
    max-width: 1296px
    width: 100%
.sizer
    padding-left: 17.4375% * 1.4814814815
    background-color: #ff2b2a
    padding-right: 8.2291666667% * 1.4814814815
    padding-top: 10.25%
    margin-top: -11.875% * 1.4814814815
    padding-bottom: 6.25%
    overflow: hidden
    position: relative
    @include media-breakpoint-down($lg)
        padding-left: 72 / 750 * 100%
        padding-right: 72 / 750 * 100%
        margin-top: 0
    @include media-breakpoint-down($sm)
        padding-top: 9.6%
        padding-bottom: 9.6%
    @media print
        padding-top: 0
        margin-top: .6cm
        margin-bottom: 0
        padding-bottom: 0
    &:before
        content: ""
        display: block
        width: 100%
        height: 670px
        left: 0
        top: 0
        position: absolute
        z-index: 0
        background: url(/img/cross.502813a6.svg) repeat center
        background-size: 45px 45px
        background-position: 0 0
        opacity: 0.15
.headline
    position: absolute
    top: 0
    left: 0
    margin-left: 8.5%
    margin-top: -4%
    font-size: 50px
    font-weight: 500
    transform: translateX(-50%) translateY(-50%) rotate(-90deg)
    @include media-breakpoint-down($lg)
        transform: translateX(-50%) translateY(-150%) rotate(-90deg)
        font-size: 35px
    @include media-breakpoint-down($sm)
        font-size: 17px
        position: static
        transform: none
        margin: 0
        margin-bottom: .3em
        &.helper
            display: none
    @media print
        display: none
    &.helper
        color: #ff2b2a
h2
    font-size: 86px
    font-weight: 500
    @include media-breakpoint-down($sm)
        font-size: 50px
    @media print
        font-size: 28px
p
    font-size: 28px
    line-height: 1.6071428571
    margin-top: 8.25%
    @include media-breakpoint-down($lg)
        font-size: 35px
    @include media-breakpoint-down($sm)
        font-size: 17px
    @media print
        font-size: 17px
        margin-top: .6cm
.cta
    margin-top: 8.25%
    @media print
        margin-top: .6cm
        position: relative
        overflow: visible
        border: none
        &:after
            content: "https://www.soletanche-bachy.com" attr(href)
            font-size: 12px
            font-weight: normal
</style>
